import { getOrCreate, linkChildren } from 'src/api/greenhouse/HydrateUtils';
import { Department, Job, Office } from 'src/api/greenhouse/hydratedTypes.greenhouse';
import { OfficeJson } from './contentTypes.greenhouse';

export type HydratedOffices = ReturnType<typeof hydrateOffices>;
export function hydrateOffices(json: OfficeJson[]) {
  const offices = new Map<number, Office>();
  const departments = new Map<number, Department>();
  const jobs = new Map<number, Job>();

  // process the whole response once
  json.forEach(officeJson => {
    // lookup the office, or make a new one
    const office: Office = getOrCreate(offices, officeJson.id, () => ({
      ...officeJson,
      children: new Set(),
      departments: new Set(),
      jobs: new Set(),
    }));

    // process the office departments
    officeJson.departments.forEach(departmentJson => {
      // lookup the department or make a new one
      const department: Department = getOrCreate(departments, departmentJson.id, () => ({
        ...departmentJson,
        children: new Set(),
        offices: new Set(),
        jobs: new Set(),
      }));

      // process the department jobs
      departmentJson.jobs.forEach(jobJson => {
        // lookup the job or make a new one
        const job: Job = getOrCreate(jobs, jobJson.id, () => ({
          ...jobJson,
          locationName: jobJson.location.name,
          // link job to department
          department,
          offices: new Set(),
        }));

        // link the department to the job
        department.jobs.add(job);

        // link the office to the job (both ways)
        job.offices.add(office);
        office.jobs.add(job);
      });

      // link the department to the office (both ways)
      department.offices.add(office);
      office.departments.add(department);
    });
  });

  // link children
  [ offices, departments ].forEach(linkChildren);

  return { offices, departments, jobs };
}
